import './FilterTableRow.scss'
import { useContext, useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import FiltersContext from '../../../../Context/FiltersContext'
import { ProjectHexagon } from './ProjectHexagon'
import { COUNTRY_COLORS } from '../../../constants/country-color'
import { FilterTableRowExpanded } from './FilterTableRowExpanded'
// import { data } from '../../../data/data_actualizado_convertido'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
// import InfoOutlineIcon from '@mui/icons-material/InfoOutline'

import { useTranslation } from 'react-i18next'
import { IProyectos } from '../../../data/data.model'
import { CustomToolTip } from '../../CustomToolTip/CustomToolTip'

interface IFilterTableRow {
  estado: string
  data: IProyectos[]
  id_estado: string
}

export const FilterTableRow = ({
  estado,
  data,
  id_estado,
}: IFilterTableRow) => {
  const { t }: any = useTranslation()
  const { filtersSelected } = useContext(FiltersContext)
  const [displayedData, setDisplayedData] = useState<IProyectos[]>(data)
  const [isRowExpanded, setIsRowExpanded] = useState<boolean>(false)

  useEffect(() => {
    const filteredProyects = filterProjects()

    setDisplayedData(filteredProyects)
  }, [filtersSelected])

  const filterProjects = (): IProyectos[] => {
    return data.filter((project) => {
      return Object.entries(filtersSelected).every(([key, values]) => {
        // Si no hay values o si el array incluye "Todos", no filtrar por esa key
        if (
          !Array.isArray(values) ||
          values.length === 0 ||
          values.map((value) => value.value).includes(t('filters.all'))
        ) {
          return true
        }
        // Filtrar si el valor del proyecto está en los values del filtro

        const valorProyecto = project[key as keyof IProyectos]

        if (Array.isArray(valorProyecto)) {
          return valorProyecto.some((value) =>
            values.map((value) => value.value).includes(value)
          )
        }
        return values
          .map((value) => value.value)
          .includes(valorProyecto as string)
      })
    })
  }

  const getCountryColor = (country: string): string => {
    switch (country) {
      case 'brasil':
        return COUNTRY_COLORS.brasil
      case 'colombia':
        return COUNTRY_COLORS.colombia
      case 'peru':
        return COUNTRY_COLORS.peru

      default:
        return ''
    }
  }

  return (
    <div className="table-row_container">
      <div className="table-row_mainDisplay">
        <div className="table-row_estado">
          {estado}
          <div className="table-row_estado_tooltip">
            <CustomToolTip title={t(`filters.tooltips.${id_estado}`)}>
              <InfoOutlinedIcon />
            </CustomToolTip>
          </div>
        </div>
        <div className="tabler-row_projects">
          {displayedData?.map((project, index) => {
            return (
              <ProjectHexagon
                key={index}
                project={project}
                size={10}
                fill={getCountryColor(project.id_pais)}
              ></ProjectHexagon>
            )
          })}
        </div>

        <div
          className="table-row_expand-btn"
          onClick={() => {
            setIsRowExpanded(!isRowExpanded)
          }}
        >
          {isRowExpanded ? <RemoveIcon></RemoveIcon> : <AddIcon></AddIcon>}
        </div>
      </div>
      {isRowExpanded ? (
        <FilterTableRowExpanded data={displayedData}></FilterTableRowExpanded>
      ) : null}
    </div>
  )
}
